<template>
    <div
        :class="[
            'aon-checkbox',
            { disabled: disabled },
            { 'remove-margins': removeMargins },
            { 'error-alert': error },
        ]"
    >
        <AonAlertBox
            v-if="error"
            class="mb-2"
            :isContextual="true"
            :title="errorOptions.errorMsg"
            type="error"
        />
        <label
            :class="[
                'label',
                'checkbox-container',
                extraClass,
                { 'remove-margins': removeMargins },
            ]"
            :for="modelLabel"
        >
            {{ label }}
            <input
                :id="modelLabel"
                v-model="shouldBeChecked"   
                :tabindex="disabled ? '-1' : '0'"
                type="checkbox"
                @click="clicked"
            />
            <span class="checkmark">
                <font-awesome-icon icon="far fa-check" class="icon white--text" />
            </span>
            <span v-if="subsetChecked" class="checkmark subset">
                <div class="subset-check"></div>
            </span>
        </label>
    </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import AonAlertBox from '../AonAlertBox.vue';

const props = defineProps({
    modelLabel: {
        type: String,
        default: null,
    },
    label: {
        type: String,
        default: null,
    },
    isChecked: {
        type: Boolean,
        default: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    extraClass: {
        type: String,
        default: '',
    },
    removeMargins: {
        type: Boolean,
        default: false,
    },
    // Hoping to have some sort of validator for errors
    error: {
        type: Boolean,
        default: false,
    },
    errorOptions: {
        type: Object,
        default: () => {
            return {
                errorMsg: ''
            }
        },
    },
})

const emit = defineEmits(['clear', 'clicked', 'update:modelValue'])

const subsetChecked = ref(false)

const shouldBeChecked = computed({
    get() {
        return props.isChecked || props.subsetChecked ? true : false
    },
    set(value) {
        emit('update:modelValue', value)
    }
})

const clicked = () => {
    emit('clicked', shouldBeChecked.value);
}


</script>

<script>
    export default {
        name: 'AonDropdown'
    }
</script>

<style lang="scss">
.aon-checkbox {
    width: fit-content;

    &.remove-margins {
        padding: 0;
        width: 25px;
        height: 25px;
        margin: 0;
    }

    .checkbox-container {
        &.remove-margins {
            padding: 0;
            width: 25px;
            height: 25px;
            margin: 0 0 0 5px;
        }
    }

    .checkmark {
        .icon {
            top: 3px;
            font-size: 16px !important;
            left: 3px;
            width: 18px;
            height: 18px;

            &:before {
                margin-top: 100px;
            }
        }

        .subset-check {
            width: 15px;
            height: 2px;
            background: white;

            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    .remove-margins {
        margin: 0 !important;
    }
}
</style>
